<template>
  <div v-if="props?.isReview && isActive" @click="closeOnClickOutside" class="modal-review">
    <div class="modal-review__content max-md:w-[420px] max-md:h-[868px] w-full">
      <slot></slot>
    </div>
  </div>

  <div v-else-if="props?.isFeedback && isActive" @click="closeOnClickOutside" class="modal-feedback">
    <div class="modal-feedback__content relative md:min-w-[824px] md:min-h-[561px]">
      <slot></slot>
    </div>
  </div>

  <div v-else-if="isActive" @click="closeOnClickOutside" class="modal">
    <div class="modal__content">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, onUnmounted, defineEmits, defineProps} from 'vue'

const isActive = ref(true)
const emits = defineEmits(['close'])
const props = defineProps({
  isReview: {
    type: Boolean,
    default: () => {
      return false
    }
  },
  isFeedback: {
    type: Boolean,
    default: () => {
      return false
    }
  }
})

const event = (e) => {
    if (e.key == 'Escape')
        isActive.value = false
}

const closeOnClickOutside = ({target}) => {
    if (!target.closest('.modal__content')) {
        emits('close')
    }
}

onMounted(() => {
    document.addEventListener('keydown', event)
})

onUnmounted(() => {
    document.removeEventListener('keydown', event)
})



</script>

<style lang="scss" scoped>
@import './scss/modal.scss';
</style>